export const windowHrefId = (id: number) => {
  const href = typeof window !== 'undefined' ? window.location.href : undefined;

  return href?.split('/')[id];
};
